// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3K8RI","title":"card_title__1Wpaj","inActive":"card_inActive__2CY-x"};